module.exports = __webpack_public_path__ + "static/img/20.375dfdc0.jpg";